import { lazy } from 'react';

const PrivacyPolicy = lazy(() => import(/* webpackChunkName: "pages/privacypolicy" */ './PrivacyPolicy'));

export { PrivacyPolicy };
